import  Parser from "html-react-parser";

export const slugify = text => {
    text = removeDiacritics(Parser(text));
    return text.toString().toLowerCase()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w-]+/g, '')        // Remove all non-word chars
        .replace(/\\+/g, '-')           // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');            // Trim - from end of text
};

export const removeDiacritics = (str) => {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
};

export const isEmpty = (obj) => {
    for(var key in obj) {
        if(obj.hasOwnProperty(key))
            return false;
    }
    return true;
};

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const redirectToMobilPay = (payload) => {
    var form = document.createElement("form");
    var element1 = document.createElement("input"); 
    var element2 = document.createElement("input");  

    form.method = "POST";
    form.action = payload.payment_url;   

    element1.value= payload.env_key;
    element1.name="env_key";
    form.appendChild(element1);  

    element2.value=payload.data;
    element2.name="data";
    form.appendChild(element2);

    document.body.appendChild(form);

    form.submit();
};

export const arrayClone = (original) => {
    return JSON.parse(JSON.stringify(original));
};

/**
 * Triggers a page view event. Used in analytics
 *
 * @param   title Document title.
 * @param   location Page's location (url, without host)
 * @param   path (Optional) Page's path, defaults to location.
 */
export const pageViewEvent = (title, location, path = location) => {
    window.gtag('event', 'page_view', {
        page_title: title,
        page_location: location,
        page_path: path,
      })
};


/**
 * Formats text for meta purposes.
 *
 * @param   rawText The text that will be formatted.
 * @param   textType (Optional) The type of text. 0 for the title and 1 for the description. Defaults to 0.
 */
export const getFormattedTextForMeta = (rawText, textType = 0) => {
    if(textType !== 0 && textType !== 1)
        throw new Error('textType must be either 0 for title or 1 for description!')
    const maxLength = (textType === 0 && 60) || (textType === 1 && 160);
    let text = (textType === 0 && rawText) || (textType === 1 && rawText.substring(0,rawText.indexOf('</p>')).replace( /(<([^>]+)>)/ig, '')) ;
    let textLength = text.length;
    while(textLength >= maxLength){
            text = text.substring(0, maxLength-1);
            text = text.substring(0, text.lastIndexOf(" ")) + '...' // repeats if length is equal or more with maxLength
            textLength = text.length;
    }
    return text;
}


// WEBPACK FOOTER //
// ./src/SHARED/helpers/general.helper.js